import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { PageHero, PageHeroService } from '../../services/page-hero.service';
import { AboutSection, AboutService } from '../../services/about.service';

@Component({
  selector: 'app-about',
  imports: [],
  templateUrl: './about.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {
  hero: PageHero | null = null;
  sections: AboutSection[] = [];

  constructor(
    private readonly pageHeroService: PageHeroService,
    private readonly aboutService: AboutService
  ) {}

  ngOnInit(): void {
    this.pageHeroService.getHero('about').subscribe({
      next: hero => {
        this.hero = hero;
      },
      error: error => {
        console.error('Failed to load About hero.', error);
      }
    });

    this.aboutService.getSections().subscribe({
      next: sections => {
        this.sections = sections;
      },
      error: error => {
        console.error('Failed to load About sections.', error);
      }
    });
  }

  get heroMediaUrl(): string | null {
    return this.pageHeroService.getMediaUrl(
      this.hero?.mediaAssetId ?? null
    );
  }

  getSectionMediaUrl(section: AboutSection): string | null {
    return this.aboutService.getMediaUrl(section.mediaAssetId);
  }
}